<template>
  <div class="managerDeliveryOrderView">
    <view-frame :titleObject="titleObject" :buttonObj="buttonObj">
      <template #rightBtn="scope">
        <template v-if="custName && custName.member_actions && custName.member_actions.default_actions">
          <el-button v-show="item.action !== 'view'" v-for="(item, index) in custName.member_actions.default_actions" :key="'default_actions' + index" type="primary" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
        </template>
        <template v-if="custName && custName.member_actions && custName.member_actions.custom_actions">
          <el-button v-for="(item, index) in custName.member_actions.custom_actions" :key="'custom_actions' + index" type="primary" size="mini" @click="handleCusClick(item, custName.order_information)">{{item.name}}</el-button>
        </template>
        <!-- <el-button v-show="type !== 'view'" v-for="(item, index) in custName.member_actions.default_actions" :key="'default_actions' + index" type="primary" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
        <el-button v-for="(item, index) in custName.member_actions.custom_actions" :key="'custom_actions' + index" type="primary" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button> -->
      </template>
      <template>
        <el-card>
          <el-row>
            <el-col :span="24">
              <span class="view__text">{{$t('form.order.orderInfo')}}</span>
              <el-card class="animate__animated animate__fadeInDown" shadow="hover">
                <custome-table tableType="object" :custSpan="4" :data="custName.order_information" :dataItem="orderViewItem"></custome-table>
              </el-card>
            </el-col>
          </el-row>
          <el-row class="margintop20" :gutter="20">
            <el-col :span="12">
              <span class="view__text">{{$t('form.order.receiverInfo')}}</span>
              <el-card class="animate__animated animate__fadeInLeft" shadow="hover">
                <custome-table tableType="object" :custSpan="8" :data="custName.receiver_information" :dataItem="receiverViewItem"></custome-table>
              </el-card>
            </el-col>
            <el-col :span="12">
              <span class="view__text">{{$t('form.order.deliverInfo')}}</span>
              <el-card class="animate__animated animate__fadeInRight" shadow="hover">
                <custome-table tableType="object" :custSpan="12" :data="custName.delivery_information" :dataItem="deliveryViewItem"></custome-table>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="margintop20" v-if="custName.delivery_order_items && custName.delivery_order_items.length > 0">
          <el-row>
            <el-col :span="24">
              <span class="view__text">{{$t('form.order.items')}}</span>
              <el-card class="animate__animated animate__fadeInLeft" shadow="hover">
                <span class="view__text"></span>
                <createTable :autoWidth="true" :tableDataItem="tableDataViewItem" :operateVisible="false" :tableData="custName.delivery_order_items" @forwardToPage="handleOrderItemsTableForwardToPage"></createTable>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="margintop20" v-if="custName.shop_payments && custName.shop_payments.length > 0">
          <el-row>
            <el-col :span="24">
              <span class="view__text">{{$t('menu.userOrder')}}</span>
              <el-card class="animate__animated animate__fadeInUp" shadow="hover">
                <span class="view__text"></span>
                <createTable :operationColWidth="isEn ? 160 : 120" :autoWidth="true" :tableDataItem="tableUserDataItem" :operateVisible="true" :tableData="custName.shop_payments">
                  <template #rightBtn="scope">
                    <template v-if="scope.row && scope.row.member_actions && scope.row.member_actions.default_actions">
                      <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
                    </template>
                    <template v-if="scope.row && scope.row.member_actions && scope.row.member_actions.custom_actions">
                      <!-- <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row, 'del')">{{item.name}}</el-button> -->
                      <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button>
                    </template>
                    <!-- <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
                      <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button> -->
                  </template>
                </createTable>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="margintop20">
          <el-row>
            <el-col :span="24">
              <span class="view__text">{{$t('form.common.changeHistory')}}</span>
              <el-card class="animate__animated animate__fadeInUp" shadow="hover">
                <span class="view__text"></span>
                <createTable :autoWidth="true" :tableDataItem="historyTableItem" :operateVisible="false" :tableData="historyTableData"></createTable>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </template>
    </view-frame>
    <dialogEffect :dateArray="dateArray" v-if="dialogVisible" :opereteDate="true" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm"></dialogEffect>
  </div>
</template>

<script>
import { getDeliveryOrderDetails } from '@/services/order'
import history from '@/common/data/jsonData'
import { getHistoryList } from '@/services/resource'
import createTable from '@/components/createTable'
import viewFrame from '@/components/viewFrame'
import customeTable from '@/components/customeTable'
import loading from '@/utils/loading.json'
import dialogEffect from '@/components/dialogEffect'
import jsonData from './jsonData'
// import Utils from '@/utils/Utils'
import { mixin } from '@/mixins/viewDiolog'
import { mapGetters } from 'vuex'

export default {
  components: {
    createTable,
    viewFrame,
    customeTable,
    dialogEffect
  },
  mixins: [mixin],
  data () {
    return {
      validateVisible: false,
      buttonObj: [],
      titleObject: {
        show: true
      },
      custName: {},
      formData: {},
      modifyData: {},
      type: '',
      orderViewItem: jsonData.orderViewItem,
      receiverViewItem: jsonData.receiverViewItem,
      deliveryViewItem: jsonData.deliveryViewItem,
      amountViewItem: jsonData.amountViewItem,
      tableDataViewItem: jsonData.tableDataViewItem,
      tableUserDataItem: jsonData.tableUserDataItem,
      historyTableItem: history.historyTableItem,
      historyTableData: []
    }
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.validateVisible = false
    next()
  },
  computed: {
    isEn () {
      if (typeof this.language === 'string'  && this.language.toLowerCase().includes('en')) return true
      else return false
    },
    ...mapGetters([
      'language'
      // ...
    ])
  },
  created () {
    this.init()
  },
  methods: {
    // 初始化
    async init () {
      this.$store.state.app.loading = this.$loading(loading)
      const res = await getDeliveryOrderDetails(this.$route.params.id)
      if (res.status === 200) {
        this.custName = res.data.delivery_order
        Object.assign(this.titleObject, { title: this.$t('form.order.order') + ' No. ', data: this.custName.order_number })
      }
      this.$store.state.app.loading.close()
      this.getDetail()
    },
    getDetail () {
      const $this = this
      if (this.custName.delivery_order_items && this.custName.delivery_order_items.length > 0) {
        Object.keys(this.custName.delivery_order_items[0]).forEach(item => {
          const index = this.tableDataViewItem.findIndex(fditem => fditem.prop === item)
          this.tableDataViewItem[index].label = this.custName.delivery_order_items[0][item].name
        })
      }
      if (this.custName.shop_payments && this.custName.shop_payments.length > 0) {
        Object.keys(this.custName.shop_payments[0]).forEach(item => {
          if (item === 'member_actions') return
          const index = $this.tableUserDataItem.findIndex(fditem => fditem.prop === item)
          if (index >= 0) $this.tableUserDataItem[index].label = $this.custName.shop_payments[0][item].name
        })
      }
      //  获取历史操作
      getHistoryList({ item_type: 'DeliveryOrder', item_id: this.$route.params.id }).then(res => {
        if (res.status === 200) {
          this.historyTableData = res.data.versions
        }
      })
    },
    async handleClick (type, data) {
      if (type?.action === 'view') {
        this.$router.push({
          name: 'ordersManagerUserOrdersDetail',
          params: {
            id: data.id.value
          }
        })
      }
    },
    async dialogSearch () {
      this.init()
    },
    gobackRouter () {
      this.$router.go(-1)
    },
    handleOrderItemsTableForwardToPage (data, name) {
      if (name === 'shop_item') {
        this.$router.push({
          name: 'goodsManagerProductDetail',
          params: {
            id: data.id
          }
        })
      } else if (name === 'shop_item_stock') {
        this.$router.push({
          name: 'goodsManagerVariationsDetail',
          params: {
            id: data.id
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scope>
</style>
